import React from "react";
import Icon_Error from "assets/Icon_Warning.png";

const NotFound: React.FC = () => {
  return (
    <div className="NotFound">
      <img src={Icon_Error} alt="Error"/>
      <h2 style={{color: "#FF474C"}}>Error: page not found.</h2>
    </div>
  );
};

export default NotFound;
